import { assertUnreachable } from 'lib/staticAssert/staticAssertUtils'
import { formatAssistantRoomsOccupancyText } from 'tripPlanner/assistant/utils/assistantRoomOccupancyText'
import type { ListingDrawerHotelDateSelection } from '../ListingDrawerSearchDates'

function formatDateSelectionSuffix(dateSelection: ListingDrawerHotelDateSelection): string {
  switch (dateSelection.type) {
    case 'specific':
      return `, ${dateSelection.checkIn} to ${dateSelection.checkOut}`
    case 'flexible':
      return `, flexible ${dateSelection.flexibleNights} nights`
    case 'anytime':
      return ''
    default:
      return assertUnreachable(dateSelection)
  }
}

// Included so a rooms-only reapply (same destination/dates, different occupancy) produces a
// displayText distinct from the original search -- otherwise the two are indistinguishable and
// the server's kind+displayText grouping silently absorbs the occupancy change into the earlier
// entry, losing the fact that the customer changed party size at all.
function formatOccupancySuffix(occupancies: Array<App.Occupants>): string {
  const occupancyText = formatAssistantRoomsOccupancyText(occupancies)
  return occupancyText ? `, ${occupancyText}` : ''
}

// Shared by both the activity entry (`hotel_search_submitted`) and the committed-state entry
// (`last_hotel_search`) -- same underlying search, same customer-facing summary, so one composer
// rather than two copies that could silently drift apart.
export function formatHotelSearchDisplayText(
  searchQuery: string,
  dateSelection: ListingDrawerHotelDateSelection,
  occupancies: Array<App.Occupants>,
): string {
  return `Searched hotels for "${searchQuery}"${formatDateSelectionSuffix(dateSelection)}${formatOccupancySuffix(occupancies)}`
}
